module.exports = __webpack_public_path__ + "static/media/LoaderIA.0793c080.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assests/img/LoaderIA.gif
// module id = 626
// module chunks = 0